import { LoadAllDoctorRegisters } from 'domain/usecases/doctor/load-all-doctor-registers'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadAllDoctorRegisters implements LoadAllDoctorRegisters {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  load(
    params: LoadAllDoctorRegisters.Params
  ): Promise<LoadAllDoctorRegisters.Model> {
    return this.doctorRepository.loadAllDoctorRegisters(params)
  }
}
